export const customMetaData = {
  id: '02E94BF5-B7C8-5224-8D74-5D918B93A727',
  name: '',
  memberName: '',
  description: '',
  alternateDescription: '',
  ordinalPosition: 7,
  relatedMemberName: null,
  relatedMemberDisplayField: null,
  columnHeading: '',
  alternateColumnHeading: '',
  columnWidth: 1,
  maxColumnWidth: 1,
  decimals: 0,
  dataType: 'C',
  requiredData: 0,
  columnPrompt: '',
  alternateColumnPrompt: '',
  isUserEditable: false,
  pickListType: null,
  pickListName: null,
  minValue: 0,
  maxValue: 0,
  defaultValue: null,
  changeControl: 0,
  displayColumn: null,
  updatedBy: '',
  updatedTime: '',
  isQueryable: false,
  metadataTableId: '',
  projectId: '',
};
